'use client';

import { BarChart, PieChart } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';

export default function CustomToggle({ options, value: defaultValue, onChange }) {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      setValue(newValue);
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="view toggle"
      sx={{
        backgroundColor: '#ebebeb',
        padding: '4px',
        borderRadius: '12px',
        gap: '4px',
        '& .MuiToggleButton-root': {
          border: 'none',
          borderRadius: '8px !important',
          padding: '8px',
          '&.Mui-selected': {
            backgroundColor: '#fff',
            '&:hover': {
              backgroundColor: '#fff',
            },
          },
        },
      }}
    >
      {options?.map(({ value: optionValue, icon: Icon, label }) => (
        <ToggleButton key={optionValue} value={optionValue} aria-label={label}>
          <Icon />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

CustomToggle.defaultProps = {
  options: [
    { value: 'bar', icon: BarChart, label: 'Chart view' },
    { value: 'pie', icon: PieChart, label: 'Pie chart view' },
  ],
  value: 'bar',
  onChange: () => {},
};
